import { render, staticRenderFns } from "./BasketPreview.vue?vue&type=template&id=05e05704&scoped=true"
import script from "./BasketPreview.vue?vue&type=script&lang=js"
export * from "./BasketPreview.vue?vue&type=script&lang=js"
import style0 from "./BasketPreview.vue?vue&type=style&index=0&id=05e05704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e05704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCheckbox,VIcon})
